import React from 'react'
import PropTypes from 'prop-types'
import { AnimatePresence, motion } from 'framer-motion'
import { isEmpty } from 'lodash'
import { sliderTransition, sliderVariants } from '../OurProperties/const'
import SelectAic from '@/components/shared/components/selectAic'
import Button from '@/components/shared/components/Button/Button'
import useOurVenues from './useOurVenues'
import Skeleton from './components'
import './styles.scss'

OurVenues.propTypes = {
  data: PropTypes.object,
}

const activeColor = '#fff'

export default function OurVenues({ data }) {
  const {
    currentHotel,
    onChangeHotel,
    hotels,
    swipeToVenue,
    direction,
    activeVenueIndex,
    dragEndHandler,
    venueCount,
    currentVenue,
    allLoading,
    loadingHotelSelected,
  } = useOurVenues()

  if (allLoading || loadingHotelSelected)
    return (
      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{
            duration: 1,
          }}
        >
          <section className="h-screen aic-2k:h-[940px] bg-gray-500">
            <div className="main-container flex flex-col h-full">
              <div className="mt-[130px] md:mt-[108px] mb-auto our-properties__header">
                <h3 className="heading2 text-[45px] md:text-[60px] lg:text-[70px] leading-none uppercase text-white mb-5">
                  {data?.title}
                </h3>
                <SelectAic
                  light
                  isLoading={allLoading || loadingHotelSelected}
                  value={currentHotel}
                  onChange={(data) => {
                    onChangeHotel(data)
                  }}
                  options={hotels}
                />
              </div>
              <Skeleton />
            </div>
          </section>
        </motion.div>
      </AnimatePresence>
    )

  return (
    <section className="our-venues">
      <div className="slider-container h-screen max-h-[950px]">
        <div className="slider h-full">
          <div className="main-container flex flex-col z-10 h-full">
            {/* Header */}
            <div className="z-20 mt-[130px] md:mt-[108px] mb-auto our-venues__header">
              <h3 className="heading2 text-[45px] md:text-[60px] lg:text-[70px] leading-none uppercase text-white z-10 mb-5">
                our venues
              </h3>

              <SelectAic
                light
                value={currentHotel}
                onChange={(data) => {
                  onChangeHotel(data)
                }}
                options={hotels}
              />
            </div>

            {/* Footer */}
            <div className="mt-auto mb-[76px] z-10">
              <div className="flex flex-col gap-1 mb-8">
                <span className="paragraph leading-none text-white">
                  {currentVenue?.venue_size}
                </span>
                <span className="heading3 text-[30px] leading-none text-white uppercase">
                  {currentVenue?.venue_name}
                </span>
              </div>
              <div className=" flex flex-raw justify-between items-center gap-3">
                <div className="flex align-center gap-4">
                  <Button
                    action={() => swipeToVenue(-1)}
                    type="icon"
                    icon="ArrowLeft"
                    iconFill="transparent"
                    iconStroke={activeColor}
                    strokeCircle={activeColor}
                    strokeOnHover={'#1B1F24'}
                  />
                  <Button
                    action={() => swipeToVenue(1)}
                    type="icon"
                    icon="ArrowRight"
                    iconFill="transparent"
                    iconStroke={activeColor}
                    strokeCircle={activeColor}
                    strokeOnHover={'#1B1F24'}
                  />
                </div>
                <span className="paragraph text-white">{`${activeVenueIndex + 1} / ${currentHotel?.totalVenues}`}</span>
              </div>
            </div>
          </div>
          <AnimatePresence initial={false} custom={direction}>
            {!isEmpty(currentVenue) ? (
              <motion.div
                key={venueCount}
                style={{
                  background: `url(${currentVenue?.venue_image?.url})`,
                  boxShadow: `inset 0 0 0 2000px rgba(27, 31, 36, 0.3)`,
                }}
                custom={direction}
                variants={sliderVariants}
                initial="incoming"
                animate="active"
                exit="exit"
                transition={sliderTransition}
                drag="x"
                dragConstraints={{ left: 0, right: 0 }}
                dragElastic={0}
                onDragEnd={(_, dragInfo) => dragEndHandler(dragInfo)}
                className="image"
              />
            ) : null}
          </AnimatePresence>
        </div>
      </div>
    </section>
  )
}
